import client from '@libs/HttpClient';
class UserService {
  static getProfile(request) {
    return client.get('/user/get-profile', request);
  }
  static updatePassword(request) {
    return client.put('/user/change-password', request);
  }
  static updateProfile(request) {
    return client.post('/user/update-profile', request, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  static getCountryCodeList(request) {
    return client.get('/common/country-code-list', request);
  }
  static updateEmailVerify(request) {
    return client.post('/user/verify-email', request, {});
  }
  static updateEmail(request) {
    return client.post('/user/update-email', request, {});
  }

  static listDepartmentAndDesignationService(request) {
      const page_no = request.page_no;
      return client.get(
        `/user/department-designation?page=${page_no}`,
        request
      );
    }

  static listMyProfileSkillsService(request) {
    const page_no = request.page_no;
    return client.get(
      `/user/profile-skills?page=${page_no}`,
      request
    );
  }
}
export { UserService };
